import { Box } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import {
    ConversationClassifier,
    IRBCHighlight,
} from "services/ConversationService";
import AcxChipList from "components/UI/AcxChipList";
import { FTSHighlights } from "./FTSHighlights";

interface RBCSearchHighlightProps {
    RBCHighlight: IRBCHighlight;
    conversationClassifiers: ConversationClassifier[];
    isChat: boolean;
    disableChips?: boolean;
}

const RBCSearchHighlight: React.FC<RBCSearchHighlightProps> = observer(
    ({
        RBCHighlight: {
            speaker0Highlights,
            speaker1Highlights,
            speaker2Highlights,
            speaker3Highlights,
            classifierName,
        },
        isChat,
        disableChips,
    }) => {
        return (
            <Box sx={{ marginBottom: 1 }}>
                <FTSHighlights
                    highlights={{
                        fullTextSearchHighlightsSpeaker0: speaker0Highlights,
                        fullTextSearchHighlightsSpeaker1: speaker1Highlights,
                        fullTextSearchHighlightsSpeaker2: speaker2Highlights,
                        fullTextSearchHighlightsSpeaker3: speaker3Highlights,
                    }}
                    disableAllChips
                    isChat={isChat}
                />
                {!disableChips && (
                    <AcxChipList
                        size="small"
                        color="gray"
                        values={[classifierName]}
                    />
                )}
            </Box>
        );
    },
);

export default RBCSearchHighlight;
